// library imports
import { Button, Form, Flex, DatePicker, Select, InputNumber, Input } from "antd";
import { useEffect, useState, useContext } from "react";
import dayjs from "dayjs";
// config imports
import { FORM_REQUIRED } from "../../../configs/configs";
// hook imports
import useFetch from "../../../hooks/useFetch";
// context imports
import { IndexContext } from "../../../context/IndexContext";

function PublicHolidaysForm(props) {
  const {
    mode,
    setIsPublicHolidaysFormModalOpen,
    refreshTable,
    initialValues,
    selectedYear,
  } = props;

  const [fetchWrapper] = useFetch();

  // loading states
  const [loadingSubmitButton, setLoadingSubmitButton] = useState(false);

  // form
  const [publicHolidaysForm] = Form.useForm();

  // load index context
  const { notificationApi } = useContext(IndexContext);

  /* API to add public holiday */
  function addPublicHoliday(user_inputs) {
    setLoadingSubmitButton(true);

    fetchWrapper({
      endpoint_url: "public_holidays_management/addPublicHoliday",
      body: {
        year: selectedYear.format("YYYY"),
        remark: user_inputs.Remark,
        date: user_inputs.Date.startOf("day").format("YYYY-MM-DD"),
      },

      onSuccess: (response) => {
        notificationApi.success({
          message: response.message,
        });
        setIsPublicHolidaysFormModalOpen(false);
        publicHolidaysForm.resetFields();
        refreshTable();
      },

      onResponseError: (response) => {
        notificationApi.error({
          message: "Failed to add Public Holiday.",
          description: response.statusText,
        });
      },

      onFinish: () => {
        setLoadingSubmitButton(false);
      },
    });
  }

  /* API to edit public holiday */
  function editPublicHoliday(user_inputs) {
    setLoadingSubmitButton(true);

    fetchWrapper({
      endpoint_url: "public_holidays_management/editPublicHoliday",
      body: {
        public_holiday_id: initialValues.ID,
        year: selectedYear.format("YYYY"),
        remark: user_inputs.Remark,
        date: user_inputs.Date.startOf("day").format("YYYY-MM-DD"),
      },

      onSuccess: (response) => {
        notificationApi.success({
          message: response.message,
        });
        setIsPublicHolidaysFormModalOpen(false);
        publicHolidaysForm.resetFields();
        refreshTable();
      },

      onResponseError: (response) => {
        notificationApi.error({
          message: "Failed to edit Public Holiday.",
          description: response.statusText,
        });
      },

      onFinish: () => {
        setLoadingSubmitButton(false);
      },
    });
  }

    useEffect(() => {
    if (mode === "edit" && initialValues) {
        publicHolidaysForm.setFieldsValue({
        ...initialValues,
        Date: dayjs(initialValues.Date),
        });
    }
    }, [mode, initialValues, publicHolidaysForm]);

  return (
    <>
      <Form
        form={publicHolidaysForm}
        name="public-holiday-form"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        onFinish={(values) => {
          if (mode === "add") {
            addPublicHoliday(values);
          } else {
            editPublicHoliday(values);
          }
        }}
        autoComplete="off"
      >
        <Form.Item
          label="Remark"
          name="Remark"
          rules={[
            {
              required: FORM_REQUIRED,
              message: "Remark cannot be empty.",
            },
          ]}
        >
          <Input placeholder="Enter remark" />
        </Form.Item>

        <Form.Item
          label="Date"
          name="Date"
          rules={[
            {
              required: FORM_REQUIRED,
              message: "Date cannot be empty.",
            },
          ]}
        >
          <DatePicker
            style={{ width: "100%" }}
            picker="date"
            minDate={dayjs(selectedYear.startOf("year"), "YYYY-MM-DD")}
            maxDate={dayjs(selectedYear.endOf("year"), "YYYY-MM-DD")}
          />
        </Form.Item>

        <Flex justify="center">
          <Button
            className="mr-2"
            onClick={() => {
              setIsPublicHolidaysFormModalOpen(false);
              publicHolidaysForm.resetFields();
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loadingSubmitButton}
          >
            Submit
          </Button>
        </Flex>
      </Form>
    </>
  );
}

export default PublicHolidaysForm;
